import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useLanguage } from '../components/Navbar';
import SEO from '../components/SEO';

const PageSection = styled.section`
  padding: 120px 0 80px;
`;

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const PageTitle = styled(motion.h1)`
  font-size: 3.5rem;
  font-weight: 800;
  margin-bottom: 1.5rem;
  position: relative;
  display: inline-block;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background-color: #ff0000;
  }
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const PageSubtitle = styled(motion.p)`
  font-size: 1.2rem;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
  color: #666;
`;

const Achievements: React.FC = () => {
  const { language } = useLanguage();
  
  // SEO metadata for Achievements page
  const achievementsSeoData = {
    en: {
      title: 'Achievements - Barkin Sayin | Awards & Recognition',
      description: 'Explore Barkin Sayin\'s career achievements, awards, and recognition in fintech innovation, smart TV technology development, and entrepreneurial excellence.',
      keywords: [
        'Barkin Sayin achievements',
        'fintech awards',
        'entrepreneur recognition',
        'technology innovation awards',
        'Trade on TV success',
        'business accomplishments',
        'digital transformation awards'
      ]
    },
    tr: {
      title: 'Başarılar - Barkın Sayın | Ödüller & Tanınma',
      description: 'Barkın Sayın\'ın fintech inovasyonu, akıllı TV teknolojisi geliştirme ve girişimcilik mükemmelliğindeki kariyer başarılarını, ödüllerini ve tanınırlığını keşfedin.',
      keywords: [
        'Barkın Sayın başarıları',
        'fintech ödülleri',
        'girişimci tanınırlığı',
        'teknoloji inovasyon ödülleri',
        'Trade on TV başarısı',
        'iş başarıları',
        'dijital dönüşüm ödülleri'
      ]
    }
  };
  
  const seoTitle = achievementsSeoData[language as keyof typeof achievementsSeoData]?.title || achievementsSeoData.en.title;
  const seoDescription = achievementsSeoData[language as keyof typeof achievementsSeoData]?.description || achievementsSeoData.en.description;
  const seoKeywords = achievementsSeoData[language as keyof typeof achievementsSeoData]?.keywords || achievementsSeoData.en.keywords;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <SEO 
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
      />
      
      <PageSection>
        <PageContainer>
          <PageHeader>
            <PageTitle
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Achievements
            </PageTitle>
            
            <PageSubtitle
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Recognition, awards, and milestones achieved throughout Barkın Sayın's entrepreneurial journey.
            </PageSubtitle>
          </PageHeader>
          
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <p style={{ textAlign: 'center' }}>Achievements content coming soon.</p>
          </motion.div>
        </PageContainer>
      </PageSection>
    </motion.div>
  );
};

export default Achievements; 